$(() => {
  const listing_upload_input = $('#listing-image-upload-input');
  const discountInput = $('#listing_discount_percentage');
  const originalPrice = $('#listing_original_price');
  const dealPrice = $('#listing_deal_price');

  // Handle Form Submit
  $('.listings_form_submit').on('click', () => {
    // $('#new_listing').trigger('submit');
    // $('form.edit_listing').trigger('submit');
    $('input[type="submit"]').trigger('click');
    if (!listing_upload_input[0].files.length) {
      $('.custom-image-input').addClass('ERROR_FIELD');
    }
  });

  // Open Image Select box
  $('.upload-listing-image').on('click', () => {
    listing_upload_input.trigger('click');
  });

  $('#clear_from_return').on('click', () => {
    // Clear Form
    $('form')[0].reset();
    window.location.pathname = window.Routes.account_path();
  });

  // disable original and deal price
  $('#listing_discount_percentage').on('change', e => {
    if (discountInput.val().length > 0) {
      originalPrice.val('');
      dealPrice.val('');
      originalPrice.prop('disabled', true);
      dealPrice.prop('disabled', true);
    } else if (discountInput.val().length === 0) {
      originalPrice.prop('disabled', false);
      dealPrice.prop('disabled', false);
    }
  });

  // disable discount percentage from original price
  $('#listing_original_price').on('change', e => {
    const discountPercentage = $('#listing_discount_percentage');
    if (originalPrice.val().length > 0) {
      discountPercentage.val('');
      discountPercentage.prop('disabled', true);
    } else if (
      originalPrice.val().length === 0 &&
      dealPrice.val().length === 0
    ) {
      discountPercentage.prop('disabled', false);
    }
  });

  // disable discount percentage from deal price
  $('#listing_deal_price').on('keyup', e => {
    const discountPercentage = $('#listing_discount_percentage');
    if (dealPrice.val().length > 0) {
      discountPercentage.val('');
      discountPercentage.prop('disabled', true);
    } else if (
      originalPrice.val().length === 0 &&
      dealPrice.val().length === 0
    ) {
      discountPercentage.prop('disabled', false);
    }
  });
});
